<template>
    <div class="font-satoshi_r">
        <div class=" px-5">
            <div class="mb-3">
                <h3 class="text-lg font-medium text-white">
                    Nominees
                </h3>
            </div>

            <div class="">
                <div class="grid grid-cols-2 place-items-center h-full gap-y-4 gap-x-2 sm:gap-x-10">
                    <div 
                        v-for="data in nomineesData" 
                        :key="data.id" 
                        class="flex flex-col justify-center items-center gap-y-1"
                    >
                        <img :src="data.profile_image" alt="">

                        <div class="font-satoshi_r text-xs text-center space-x-1">
                            <span class="text-white">
                                {{ data.candidate_name }}
                            </span>

                            <br />

                            <a 
                                :href="data.social_media_link" 
                                target="_blank" 
                                class="text-white text-xs"
                            >
                                @{{ data.candidate_slug }}
                            </a>
                        </div>

                        <div class="">
                            <button 
                                @click="isConfirmVote = true, nomineData = data"
                                class="button is-primary is-rounded is-small font-satoshi_r text-xs px-5"
                            >
                                Vote
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-modal v-model="isConfirmVote" :width="430">
            <template #default="props">
                <ConfirmVote
                    :nomineData="nomineData"
                    @close="props.close" 
                />
            </template>
        </b-modal>
    </div>
</template>

<script>
    import ConfirmVote from "@/components/trendUpp/ConfirmVote.vue";

    export default {
        components: {
            ConfirmVote
        },

        data() {
            return {
                isConfirmVote: false,
                nomineData: null
            }
        },

        props: {
            nomineesData: {
                type: Array,
            }
        },

        methods: {
        },

        mounted() {
        },
    };
</script>

<style scoped>
    .spinner-bg {
		background: linear-gradient(0deg, rgba(255, 255, 255, 0.06) 0%, rgba(255, 255, 255, 0.06) 100%), #0C0C0C;
	}

    .text-1xl {
        font-size: 1.375rem /* 22px */ ;
        line-height: 2rem /* 32px */ ;
    }
</style>
